import React from 'react'
import css from './styled.module.scss'

export const ImgPlaceholder = (props) => {
  return <div className={css.img_placeholder} {...props} />
}

export const Square = (props) => {
  return <div className={css.square_block} {...props} />
}

export const CardContainer = ({ top, left, right, bottom, children, style, ...props }) => {
  return (
    <div
      className={css.card_container}
      style={{
        ...style,
        marginTop: top ? top : 'none',
        marginBottom: bottom ? bottom : 'none',
        marginLeft: left ? left : 'none',
        marginRight: right ? right : 'none',
      }}
      {...props}
    >
      {children}
    </div>
  )
}
